var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1014_1038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8531 11.4831C19.8531 12.4962 19.5526 13.4867 18.9897 14.3291C18.4269 15.1715 17.6268 15.8281 16.6908 16.2158C15.7547 16.6035 14.7248 16.7049 13.7311 16.5073C12.7374 16.3096 11.8246 15.8217 11.1082 15.1053C10.3918 14.3889 9.90389 13.4761 9.70623 12.4825C9.50858 11.4888 9.61002 10.4588 9.99774 9.52273C10.3855 8.58669 11.042 7.78665 11.8845 7.22377C12.7269 6.66088 13.7173 6.36045 14.7304 6.36045C16.089 6.36045 17.392 6.90015 18.3527 7.86083C19.3134 8.82151 19.8531 10.1245 19.8531 11.4831ZM25.4935 22.2461C25.4255 22.3141 25.3448 22.3681 25.2559 22.4049C25.1671 22.4418 25.0719 22.4607 24.9757 22.4607C24.8795 22.4607 24.7843 22.4418 24.6955 22.4049C24.6066 22.3681 24.5259 22.3141 24.4579 22.2461L19.8787 17.6659C18.2862 18.9908 16.2443 19.6507 14.1776 19.5084C12.111 19.3662 10.1787 18.4327 8.78278 16.9021C7.38683 15.3716 6.63466 13.3618 6.68273 11.2908C6.73079 9.21985 7.57538 7.24712 9.04082 5.78297C10.5063 4.31882 12.4797 3.47597 14.5508 3.42974C16.6218 3.38351 18.6309 4.13745 20.1602 5.53475C21.6895 6.93204 22.6213 8.86512 22.7617 10.9319C22.9022 12.9987 22.2404 15.04 20.9142 16.6313L25.4935 21.2106C25.5615 21.2786 25.6155 21.3593 25.6523 21.4481C25.6891 21.5369 25.7081 21.6322 25.7081 21.7283C25.7081 21.8245 25.6891 21.9197 25.6523 22.0086C25.6155 22.0974 25.5615 22.1781 25.4935 22.2461ZM14.7304 18.0693C16.0331 18.0693 17.3065 17.683 18.3896 16.9593C19.4727 16.2356 20.3168 15.207 20.8153 14.0035C21.3138 12.8 21.4443 11.4758 21.1901 10.1982C20.936 8.92056 20.3087 7.74701 19.3876 6.8259C18.4665 5.9048 17.293 5.27752 16.0153 5.02339C14.7377 4.76926 13.4135 4.89969 12.21 5.39819C11.0065 5.89668 9.97788 6.74086 9.25418 7.82396C8.53047 8.90706 8.14419 10.1804 8.14419 11.4831C8.14613 13.2293 8.84066 14.9034 10.0754 16.1381C11.3101 17.3729 12.9843 18.0674 14.7304 18.0693Z",
    fill: "#263322",
    stroke: "#263322",
    strokeWidth: 0.75
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    rx: 1,
    transform: "matrix(1 0 0 -1 12.25 35)",
    fill: "#263322"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1014_1038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4.25 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSelected);
export default __webpack_public_path__ + "static/media/SearchSelected.eaf75fe84c8058f154efa48a5284199d.svg";
export { ForwardRef as ReactComponent };